/**
 * 场景模式类型枚举
 */
export enum ScenarioType {
  PURE_ROADSHOW = '纯路演',
  ROADSHOW_QA = '路演与问答',
  DD_INTERVIEW = '尽调客户访谈',
  POST_INVESTMENT = '投后管理'
}

/**
 * 场景元数据配置
 * 包含图标和描述等UI展示信息
 */
export const SCENARIO_METADATA = {
  [ScenarioType.PURE_ROADSHOW]: {
    iconName: 'FaChartLine',
    desc: '项目展示 融资计划'
  },
  [ScenarioType.ROADSHOW_QA]: {
    iconName: 'HiUserGroup',
    desc: '互动问答 深度沟通'
  },
  [ScenarioType.DD_INTERVIEW]: {
    iconName: 'FaUserTie',
    desc: '尽调访谈 信息核实'
  },
  [ScenarioType.POST_INVESTMENT]: {
    iconName: 'MdManageAccounts',
    desc: '运营监控 风险预警'
  }
} as const;
